import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconRedditStyle0 = cosmosIconCss;

const CosmosIconReddit$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconReddit extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '9af30450aa4a6e484500f986fdd7d47fb0016c25', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '1fb55ba63799b2bbbd59e231c461f3224445d7a3', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'b8b50fb8de9f7476e9f6a4463f28271cdcab4c92', d: "M20.62 11.442a2.033 2.033 0 0 0-2.036-2.035 2.05 2.05 0 0 0-1.418.567c-1.401-1-3.32-1.652-5.456-1.735l.935-4.371 3.036.65A1.453 1.453 0 1 0 17.132 3a1.45 1.45 0 0 0-1.3.818L12.445 3.1c-.1-.017-.2 0-.267.05a.325.325 0 0 0-.15.234l-1.035 4.872c-2.169.066-4.121.717-5.54 1.735a2.05 2.05 0 0 0-1.417-.567A2.033 2.033 0 0 0 3.2 13.31c-.033.2-.05.4-.05.617 0 3.137 3.654 5.69 8.159 5.69 4.505 0 8.159-2.536 8.159-5.69 0-.2-.017-.417-.05-.617a2.055 2.055 0 0 0 1.201-1.869ZM6.638 12.894a1.453 1.453 0 0 1 2.903 0c0 .8-.65 1.451-1.451 1.451-.801.017-1.452-.65-1.452-1.451Zm8.126 3.854c-1.001 1.001-2.903 1.068-3.454 1.068-.567 0-2.47-.083-3.454-1.068a.373.373 0 0 1 0-.534c.15-.15.384-.15.534 0 .634.634 1.969.851 2.92.851.951 0 2.303-.217 2.92-.85a.371.371 0 0 1 .534 0 .406.406 0 0 1 0 .533Zm-.267-2.386a1.453 1.453 0 0 1 0-2.903c.8 0 1.451.65 1.451 1.452 0 .784-.65 1.451-1.451 1.451Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconRedditStyle0; }
}, [1, "cosmos-icon-reddit", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-reddit"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-reddit":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconReddit$1);
            }
            break;
    } });
}

const CosmosIconReddit = CosmosIconReddit$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconReddit, defineCustomElement };
